export const chatNotification = {
  admin: "ADMIN",
  regular_and_admin: "REGULAR",
  current_user: "YOU",
  new: "NEW",
  confirmed: "CONFIRMED",
};
